export default "__VITE_ASSET__DzqofLVy__"